module.exports = function($) {

  $.fn.swFormValues = function() {
    var data = $(this).serializeArray();
    var values = {};

    for (var val in data) {
      if (data.hasOwnProperty(val)) {
        values[data[val].name] = data[val].value;
      }
    }

    return values;
  };

};
